import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import AppWithQueryClient from './AppWithQueryClient';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWithQueryClient />
  </React.StrictMode>
);
